import React, { useState } from 'react';
import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { saveNewExternalExamOperation } from '../operations/save-new-external-exam-operation';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { Major } from '../../../../../../api/types/settings/studies/major';
import { PaymentServiceSelector } from '../../../../../external-exams/tabs/external-exam-groups/components/payment-service-selector';

interface AddNewExternalExamDialog {
  onHide: () => any;
}
export const AddNewExternalExamDialog: React.FC<AddNewExternalExamDialog> = ({
  onHide,
}) => {
  const [examName, setExamName] = useState('');
  const [symbol, setSymbol] = useState('');
  const [majorSymbol, setMajorSymbol] = useState('');
  const [selectedMajor, setSelectedMajor] = useState<Major | null>(null);
  const [paymentServiceId, setPaymentServiceId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  const handeOnApprove = async () => {
    if (!selectedMajor) {
      return;
    }
    await saveNewExternalExamOperation(
      examName,
      symbol,
      majorSymbol,
      selectedMajor.id,
      paymentServiceId,
      setLoading,
      onHide,
    );
  };

  return (
    <div>
      <EditText
        onChange={setExamName}
        value={examName}
        title={'שם המקצוע'}
        maxLength={50}
      />
      <EditText
        onChange={setSymbol}
        value={symbol}
        title={'סמל'}
        maxLength={50}
      />
      <EditText
        onChange={setMajorSymbol}
        value={majorSymbol}
        title={'סמל מגמה'}
        maxLength={50}
      />
      <div
        style={{
          flex: '1',
          minWidth: '250px',
          marginBottom: '16px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <label style={{ fontSize: '14px', color: '#4b5563' }}>מגמה</label>
        <Dropdown
          value={selectedMajor}
          onChange={(e) => setSelectedMajor(e.value)}
          options={globalSettingsStores.majors}
          optionLabel="majorName"
          placeholder="בחירת מגמה"
          style={{
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            marginTop: '8px',
          }}
        />
      </div>
      <PaymentServiceSelector
        selectedPaymentServiceId={paymentServiceId}
        onPaymentServiceChange={(id, versionId) => {
          setPaymentServiceId(id);
        }}
      />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          onClick={handeOnApprove}
          loading={loading}
          style={{ height: '30px' }}
          label={'אישור'}
          disabled={
            !examName ||
            !symbol ||
            !majorSymbol ||
            !selectedMajor ||
            !paymentServiceId
          }
        />
      </div>
    </div>
  );
};
